
import {
  Col,
  Input,
  Row
} from 'reactstrap';

import classNames from 'classnames';
import propTypes from 'prop-types';


const InputSearch = props => {
  return (
    <Row className={classNames("input-search__wrapper", {"input-search__wrapper--has-input": props.value.length > 0})}>
      <Col className="input-search__wrapper-input" md={{size: 8, offset: 2}}  xs={8}>
        <div className="input-search__wrapper-input__control">
          <Input
            name={props.name}
            placeholder={props.placeholder}
            onChange={props.onChange}
            onKeyPress={props.onKeyPress}
            value={props.value}
            className="input-search__input"
            innerRef={props.innerRef}
          />
          {/* <Button type="button" className="input-search__clear" onClick={props.onClear}>CLEAR</Button> */}
        </div>
      </Col>
      {/* <Col className="input-search__wrapper-button" md={2} xs={4}>
        <div>
          <Button type="button" className={classNames("input-search__btn-search", {"input-search__btn-search--grey": props.isSameInput})} onClick={props.onSubmit}>
            SEARCH
          </Button>
        </div>
      </Col> */}
    </Row>
  )
}

export default InputSearch;
InputSearch.defaultProps = {
  value: '',
  name: 'search',
  isSameInput: false
}
InputSearch.propTypes = {
  value: propTypes.string,
  name: propTypes.string,
  placeholder: propTypes.string,
  isSameInput: propTypes.bool,
  innerRef: propTypes.func,
  onClear: propTypes.func,
  onSubmit: propTypes.func,
  onChange: propTypes.func,
  onKeyPress: propTypes.func
}